function isAffiliate(mcsResult) {
    return mcsResult && mcsResult.subchannel === 'Affiliates';
}

module.exports = {
    isAffiliate
};
